export enum AvatarSize {
  XXSMALL = 'xxs',
  XSMALL = 'xs',
  SMALL = 'small',
  NEWSMALL = 'newsmall',
  LARGE = 'large',
  XLARGE = 'xl',
}

export enum AvatarShape {
  CIRCLE = 'circle',
  SQUARE = 'square',
}
